import React from "react";
import TabletLayout from "../../Shared/TabletLayout";
import TabletNotice from "../../Shared/TabletNotice";
import OriginalComponentImpl from "../../../Components/Main/HomePage/Authentication/SignUp";

const OriginalComponent = OriginalComponentImpl as unknown as React.ComponentType<any>;

interface Props {
  [key: string]: any;
}

const SignUpTablet: React.FC<Props> = (props) => {
  return (
    <TabletLayout title="SignUp">
      <TabletNotice page="SignUp" />
      <OriginalComponent {...props} />
    </TabletLayout>
  );
};

export default SignUpTablet;